<script>
  import { useWallet, useDisconnect, useWalletModal } from '@do/svelte-web3-manager';
  import { getBalanceFromEth, mobileMenuActivity } from '@shared/lib';
  import { Icon } from '@shared/ui/icon';
  import { ConnectedWallet } from '@entities/wallet';

  $: balance = getBalanceFromEth($wallet?.balance);

  const wallet = useWallet();
  const disconnectWallet = useDisconnect();
  const web3Modal = useWalletModal();
</script>

{#if $wallet}
  <div>
    <div class="mb-4 mt-6">
      <ConnectedWallet />
    </div>

    <p class="mb-4 text-base font-medium">Wallet Balance</p>

    <div
      class="shadow-wallet-sidebar dark:border-default-50/10 border-default-250 mb-4 overflow-hidden rounded-lg dark:border dark:shadow-transparent"
    >
      <div class="dark:bg-alt-dark flex items-center gap-2 px-4 py-5">
        <Icon name="usdc" width="{20}" height="{20}" />

        <div class="flex items-center gap-1">
          <p class="text-[20px] font-medium leading-[24px]">{balance.usdc}</p>

          <p class="text-[20px] font-medium leading-[24px]">USDC</p>
        </div>
      </div>

      <div class="bg-default-250 dark:bg-default-50/10 h-[1px]"></div>

      <div class="dark:bg-alt-dark flex items-center gap-2 px-4 py-5">
        <Icon name="eth" width="{20}" height="{20}" />

        <div class="flex items-center gap-1">
          <p class="text-[20px] font-medium leading-[24px]">{balance.eth}</p>

          <p class="text-[20px] font-medium leading-[24px]">ETH</p>
        </div>
      </div>
    </div>

    {#if balance.usd === 0}
      <p class="text-default-600 dark:text-dark-800 mb-4">
        There are no funds in your wallet. Please top up your balance in USDC.
        <br />
        Instructions to fund your wallet are in our
        <a href="/artworks" class="underline" on:click="{mobileMenuActivity.toggle}">FAQ.</a>
      </p>
    {/if}

    <button on:click="{disconnectWallet}" class="flex items-center gap-2 py-1.5 text-base font-medium">
      <Icon name="signOut" />

      Disconnect
    </button>
  </div>
{:else}
  <button class="flex gap-2 py-1.5 text-6xl font-medium" on:click="{() => $web3Modal?.open({ view: 'Connect' })}">
    Connect Wallet
  </button>
{/if}
